<template>
  <li class="row">
    <div class="col-xs-4 col-sm-12">
      <img :src="user.profile_image_url" />
      <span class="position">{{ user.response.priority }}</span>
    </div>
    <div class="col-xs-8 col-sm-12">
      <div class="description">
        <h4>{{ user.name }}</h4>
        <p>{{ user.profile.tagline }}</p>
        <p v-if="!$hideSocialMediaReferences" :title="`${user.profile.highest_followers} followers`">
          <i :class="['fab', user.profile.highest_followers_icon]"></i> {{ user.profile.highest_followers | abbreviatedNumber }} followers
        </p>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  }
}
</script>
